<template>
  <div class="syncChat">
    <!-- <el-button type="text" @click="dialogFormVisible = true">点击打开</el-button> -->
    <el-dialog title="同步聊天记录" :visible.sync="chartVisible" :before-close="close">
      <div class="title">
        <i class="el-icon-warning" style="color:#FFB033"></i>
        选择聊天记录的时间范围，保存后会自动同步此时间段内在手机端产生的聊天记录，并保存到系统中
      </div>
      <el-form :model="form" :rules="rules" ref="form">
        <el-form-item label="聊天日期：" :label-width="formLabelWidth" prop="data">
          <el-date-picker
            v-model="form.data"
            type="daterange"
            range-separator="至"
            start-placeholder="聊天开始时间"
            end-placeholder="聊天结束时间"
            value-format="yyyy-MM-dd"
            :picker-options="pickerOptions"
          ></el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="close">取 消</el-button>
        <el-button type="primary" @click="send('form')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "syncChat",
  data() {
    return {
      // dialogFormVisible: false,
      form: {
        data: ""
      },
      formLabelWidth: "120px",
      rules: {
        data: [
          {
            type: "array",
            required: true,
            message: "请选择日期",
            trigger: "change"
          }
        ]
      },
      pickerOptions: {
        disabledDate(time) {
            return time.getTime() > Date.now() - 8.64e6
        }

      }, 
      star: "" ,
      end:""
    };
  },
  components: {},
  props: {
    chartVisible:{
      type:Boolean,
      required:''
		}
  },
  computed: {},
  watch: {},
  mounted() {
  },
  methods: {
    close(){
      this.$emit('closechart')
    },
    send(formName){
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // console.log(valid)
          this.star= new Date(this.form.data[0])
          this.end= new Date(this.form.data[1])
          if(Math.ceil((this.end.getTime(this.end)-this.star.getTime(this.star))/1000/ 60 / 60 / 24)>5){
            this.$toast('同步时间范围不可超过5天！');
          }else{
            this.$emit('closechart0',this.form.data)
          }
        } else {
          // console.log(valid);
          return false;
        }
      })
    }
  }
};
</script>
<style lang="less" scoped>
/deep/.el-dialog {
  width: 480px;
  // padding-bottom: 30px;
}
/deep/.el-dialog__body {
  .title {
    color: #2a2a2a;
    font-size: 14px;
    line-height: 22px;
    display: flex;
    vertical-align: top;
    margin-bottom: 20px;
    i {
      font-size: 20px;
      margin-right: 12px;
      line-height: 26px;
    }
  }
  .el-form-item__label{
    color: #2a2a2a;
  }
  .el-range-editor.el-input__inner {
    width: 285px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/customerservice/components/syncChart.vue